module.exports = __webpack_public_path__ + "img/withdrawal.987c8f51.png";